export const RUM_DATAPLANE_ENDPOINT = "https://dataplane.rum.us-east-1.amazonaws.com";
